
export const PinTypes = {
  /** @type {'direct'} */
  direct: 'direct',
  /** @type {'recursive'} */
  recursive: 'recursive',
  /** @type {'indirect'} */
  indirect: 'indirect',
  /** @type {'all'} */
  all: 'all'
}
